import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Buttons on the right. */
  extra?: ReactNode;
  /** Chips next to the title (status, counters). */
  tags?: ReactNode;
  back?: boolean;
}

/** One header for every page: title, optional subtitle and the page's actions on the right. */
export function PageHeader({ title, subtitle, extra, tags, back }: Props) {
  const navigate = useNavigate();
  return (
    <div className="wms-page-header">
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10, minWidth: 0 }}>
        {back && <Button type="text" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)} style={{ marginTop: 2 }} aria-label="Назад" />}
        <div style={{ minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <h1>{title}</h1>
            {tags}
          </div>
          {subtitle && <div className="wms-subtitle">{subtitle}</div>}
        </div>
      </div>
      {extra && <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>{extra}</div>}
    </div>
  );
}
